import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {ContentBlock} from '../../../../../shared/models/configuration.model';
import {Component, Inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {MatButton} from '@angular/material/button';
import { MarkdownEditorComponent } from '../../../../../shared/components/markdown-editor/markdown-editor.component';

abstract class ContentBlockDialogBase {

  public abstract dialogTitle: string;
  public abstract dialogActionTitle: string;

  protected constructor(
    public readonly dialogRef: MatDialogRef<DialogCreateContentBlockComponent>,
    public data: ContentBlock,
  ) {
  }

  handleActionButtonClick() {
    this.dialogRef.close(this.data);
  }

  onContentChange(e) {
    // console.log(e);
  }
}

@Component({
  selector: 'app-dialog-create-content-block',
  templateUrl: './dialog-edit-content-block.html',
  styleUrls: ['dialog-edit-content-block.scss', '../../../../settings/settings-fields.scss'],
  imports: [
    MatDialogTitle,
    FormsModule,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatError,
    MatInput,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MarkdownEditorComponent,
  ],
})
export class DialogCreateContentBlockComponent extends ContentBlockDialogBase {
  dialogTitle = 'Add Content Block';
  dialogActionTitle = 'Add Content Block';

  constructor(
    dialogRef: MatDialogRef<DialogCreateContentBlockComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContentBlock
  ) {
    super(dialogRef, data);
  }
}

@Component({
  selector: 'app-dialog-update-content-block',
  templateUrl: './dialog-edit-content-block.html',
  styleUrls: ['dialog-edit-content-block.scss', '../../../../settings/settings-fields.scss'],
  imports: [
    MatDialogTitle,
    FormsModule,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatError,
    MatInput,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MarkdownEditorComponent,
  ]
})
export class DialogUpdateContentBlockComponent extends ContentBlockDialogBase {

  dialogTitle = 'Update Content Block';
  dialogActionTitle = 'Update';

  constructor(
    dialogRef: MatDialogRef<DialogUpdateContentBlockComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContentBlock) {
    super(dialogRef, data);
  }
}
